import Component from "vue-class-component";
import router from "./router";
import { AppBase } from "./AppBase";

@Component({
  router,
})
export default class App extends AppBase {
  protected sourceUrl = "/data/export/pub/charging-stations-geo.json";

  protected mounted() {
    this.mounted();
  }

  protected fitCountryInView() {
    super.fitCountryInView();
  }
}
